// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"e2af89a2","294":"2060f8c8","327":"04ff6a2d","453":"acf84f54","457":"5fe3015f","585":"8846c9f0","676":"b84e894b","786":"2ee028df"}[chunkId] + ".chunk.js";
};